import utils from './utils';

/**
 * Class representing a people selector.
 */
class PeopleSelector {
  /**
   * Create a people selector.
   * @param {HTMLElement} elem - The HTML element representing the people
   *   selector.
   */
  constructor(elem) {
    this.elem = elem;
    this.othersPeopleSelectors = this.elem.closest('.search-engine-peoples').querySelectorAll(`.js-people-selector:not(#${this.elem.getAttribute('id')})`);

    this.events();
    this.updateTotalPeoples();
  }

  /**
   * Set up event listeners for the people selector.
   */
  events() {
    this.elem.addEventListener('change', () => {
      this.updateTotalPeoples();
    });
  }

  /**
   * Update the total number of people and toggle buttons accordingly.
   */
  updateTotalPeoples() {
    const currentValue = this.elem.value;
    const othersTotalValues = 0;

    let totalPeoples = Array.from(this.othersPeopleSelectors).reduce((total, otherPeopleSelector) => {
      return parseInt(total) + parseInt(otherPeopleSelector.value);
    }, othersTotalValues);

    totalPeoples += parseInt(currentValue);
    this.toggleButtons(totalPeoples);
  }

  /**
   * Toggle the disabled state of plus buttons based on the total number of
   * people.
   * @param {number} total - The total number of people selected.
   */
  toggleButtons(total) {
    // Current input buttons
    const siblingsPlusButtons = utils.getSiblingsByClass(this.elem, 'js-input-counter-plus');
    if (total === 8) {
      this.toggleDisable(siblingsPlusButtons, true);
    }
    else {
      this.toggleDisable(siblingsPlusButtons, false);
    }

    // Others inputs buttons
    this.othersPeopleSelectors.forEach((otherPeopleSelector) => {
      const otherSiblingsPlusButtons = utils.getSiblingsByClass(otherPeopleSelector, 'js-input-counter-plus');

      if (total === 8) {
        this.toggleDisable(otherSiblingsPlusButtons, true);
      }
      else {
        this.toggleDisable(otherSiblingsPlusButtons, false);
      }
    });
  }

  /**
   * Toggle the disabled state of given elements.
   * @param {Array<HTMLElement>} elementsToDisabled - An array of elements to
   *   be disabled/enabled.
   * @param {boolean} disabled - Whether to disable (true) or enable (false)
   *   the elements.
   */
  toggleDisable(elementsToDisabled, disabled) {
    elementsToDisabled.forEach((elementToDisabled) => {
      elementToDisabled.disabled = disabled;
    });
  }
}

const jsPeopleSelectors = document.querySelectorAll('.js-people-selector');
jsPeopleSelectors.forEach((jsPeopleSelector) => {
  jsPeopleSelector.peopleSelector = new PeopleSelector(jsPeopleSelector);
});